import { useEffect } from "react";

import {
    AnchorContentsResponse,
    PaidLandingPersonaTypes
} from "@/utils/anchor-queries/get-anchor-contents";
import { experiments, useExperimentExposure } from "@/utils/experiment";

import { JiraSoftwarePagePaidLpJsmAnchor } from "./paid-lp-jsm-anchor";
export interface JiraServiceManagementSoftwarePageAnchorOperationsProps {
    anchorContents?: AnchorContentsResponse | null;
    persona?: string;
}
export const JiraServiceManagementSoftwarePageAnchorOperations = (
    pageProps: JiraServiceManagementSoftwarePageAnchorOperationsProps
) => {
    const [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure] =
        useExperimentExposure(experiments.cpapiDeprecationJsmExperiment);

    useEffect(() => {
        if (!cpapiDeprecationExposureFired) {
            fireCpapiDeprecationExposure();
        }
    }, [cpapiDeprecationExposureFired, fireCpapiDeprecationExposure]);

    const pageId = "anchor-lp-jsm-team-operations";
    return (
        <JiraSoftwarePagePaidLpJsmAnchor
            {...pageProps}
            pageId={pageId}
            persona={"unknown" as PaidLandingPersonaTypes}
            pageVariant="operations"
            signupEdition="premium"
        />
    );
};
